import { Box, Button, Typography } from "@mui/material";		
import { exportClientTanTracesInbox, getClientTraceCommunication } from "api/services/automation/income-tax-tan";		
import Table from "components/Table";		
import { useMutation, useQuery } from "react-query";		
import { useNavigate, useParams } from "react-router-dom";		
import { ResType } from "types";		
import { StyledSpan } from "../../styles";		
import { useState } from "react";		
import AccessDenied from "../../Access/accessDenide";		
import Loader from "components/Loader";		
import { handleError } from "utils/handleError";
import { snack } from "components/toast";
import { getCurrentFormattedDateTime } from "utils";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { SortDirection } from "data/constants";
import sortHandler from "components/Table/SortHandler";
import _ from "lodash";

const TanTraceCommunication = (state) => {		
  const params = useParams();		
  const navigate = useNavigate();		
  const [page, setPage] = useState<number>(0);		
  const [pageCount, setPageCount] = useState<number>(10);		
  const [totalCount, setTotalCount] = useState<number>(0);		
  const [checkAccess, setCheckAccess] = useState(true);		


  let defaultColumns = [		
    {		
      key: "date",		
      title: "Date",		
      width: "120px",	
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true 	
    },		
    {		
      key: "commRefNo",		
      title: "Reference ID",		
    },		
    {		
      key: "id",		
      title: "FY",
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true ,
      width: "100px",		
      render: (row: any) => {		
        return <Box>{row?.fy ? row?.fy : "--"}</Box>;		
      },		
    },		
    {		
      key: "qt",		
      title: "Quarter",	
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,	
    },		
    {		
      key: "formType",		
      title: "Form Type",	
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,	
      render: (row: any) => {		
        return <Typography>{row?.formType ? row?.formType : "-"}</Typography>;		
      },		
    },		
   		
    {		
      key: "commCat",		
      title: "Category",
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,		
    },		
    {		
      key: "description",		
      title: "Description",
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,	
    },		
   		
    {		
      key: "type",		
      title: "Action",
      sort: true,
    active: false,
    direction: SortDirection.ASC, default: true,	
      render: (row: any) => {		
        return <Typography color={row?.type === "Required" ? "#800080" : "#008080"} sx={{fontWeight:'bold'}}>{row?.type ? row?.type : "-"}</Typography>;		
      },		
    },		
  ];
  const [sort, setSort] = useState<any>({});
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const { data, isLoading }: ResType = useQuery(		
    ["get-trace-communication", params.incometaxid, { limit: pageCount, offset: page * pageCount,sort }],		
    getClientTraceCommunication,		
    {		
      onSuccess: (res) => {		
        setCheckAccess(res?.data?.accessDenied);		
        setTotalCount(res?.data?.count);		
      },		
    }		
  );		

  const handleSort = (v: any) => {
    sortHandler({
        key: v.key,
        columns,
        sortState: sort,
        setSortState: setSort,
        setColumns: setColumns,
    });
};

  const { mutate: mutate1 } = useMutation(exportClientTanTracesInbox, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - Income Tax (TAN) Traces Inbox ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax (TAN) Traces Inbox exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    mutate1({
      ...state,
      incometaxId:params.incometaxid,		   });
  };
  if (isLoading) return <Loader />;		
  return (		
    <>		
      {!checkAccess && <AccessDenied />}		
      <Box display="flex" justifyContent="flex-end" sx={{ p: 1 }}>
                    <Button variant="outlined" color="secondary" onClick={handleExport}
                        startIcon={<FileDownloadOutlinedIcon />}>
                        Export
                    </Button>
                </Box>
      {checkAccess && (		
        <Box>		
          {data && data?.data.count > 0 ? (		
            <>		
              <Table		
                // selection={{ selected, setSelected }}
                pagination={{ totalCount, pageCount, setPageCount, page, setPage }}		
                data={data?.data?.result || []}		
                columns={columns}		
                sortHandler={handleSort}
                loading={isLoading}		
                // onRowClick={handleRowClick}
              />		
            </>		
          ) : (		
            <>		
              <Box textAlign="center" mt={20}>		
                <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">		
                  No Data present		
                </Typography>		
              </Box>		
            </>		
          )}		
        </Box>		
      )}		
    </>		
  );		
};		

export default TanTraceCommunication;